import type { Theme } from '@mui/material/styles';

import { stylesMode, varAlpha } from 'src/theme/styles';

export const getActivityDateRangePickerSx = (theme: Theme) => {
  const selectedDaySx = {
    background: `${theme.vars.palette.text.primary} !important`,
    borderColor: `${theme.vars.palette.text.primary} !important`,
    color: `${theme.vars.palette.common.white} !important`,
    [stylesMode.dark]: {
      color: `${theme.vars.palette.grey[800]} !important`,
    },
  };

  const rangeFillColor = varAlpha(theme.vars.palette.text.primaryChannel, 0.25);
  const rangeHoverBorderColor = varAlpha(theme.vars.palette.text.primaryChannel, 0.4);
  const todayBorderColor = theme.vars.palette.text.primary;

  return {
    px: 1,
    pb: 1,
    '& .mbsc-datepicker .mbsc-calendar-button.mbsc-disabled': {
      opacity: 0.38,
      pointerEvents: 'none',
    },
    '& .mbsc-material.mbsc-calendar-today:not(.mbsc-selected) .mbsc-calendar-cell-text, & .mbsc-material-dark.mbsc-calendar-today:not(.mbsc-selected) .mbsc-calendar-cell-text':
      {
        color: todayBorderColor,
        border: `1px solid ${todayBorderColor}`,
        background: 'transparent !important',
        boxSizing: 'border-box',
      },
    '& .mbsc-material.mbsc-selected .mbsc-calendar-cell-text, & .mbsc-material-dark.mbsc-selected .mbsc-calendar-cell-text':
      selectedDaySx,
    '& .mbsc-material.mbsc-range-day:after, & .mbsc-material-dark.mbsc-range-day:after': {
      backgroundColor: rangeFillColor,
    },
    '& .mbsc-material.mbsc-range-hover:before, & .mbsc-material-dark.mbsc-range-hover:before': {
      borderColor: rangeHoverBorderColor,
    },
  };
};
